var __default__ = {weekday:'m_18a3eca'};
export default __default__;